import {createPaginationItem} from "../../components/pagination/Pagination";
import {range} from "../../utils/range";
import downloadQR from "../../workers/QRWorker";

export default function ExhibitionsViewModel() {}

ExhibitionsViewModel.prototype.createPaginationItems = createPaginationItems;
ExhibitionsViewModel.prototype.getURL = getURL;
ExhibitionsViewModel.prototype.getViewExhibitionURL = getViewExhibitionURL;
ExhibitionsViewModel.prototype.downloadQRCode = downloadQRCode;
ExhibitionsViewModel.prototype.prepareExhibitionModel = prepareExhibitionModel;

function getURL(page, query) {
    const params = new URLSearchParams({
      "page": page,
    });
    if (query) {
      params.append("query", query);
    }
    return `?${params.toString()}`
}

function getViewExhibitionURL(id) {
    const params = new URLSearchParams({
      id: id,
      mobile_version: 'true',
    });
    return `/?${params.toString()}`
}

function downloadQRCode(id, callback) {
  downloadQR(id, (err) => {
      callback(err);
  });
}

function prepareExhibitionModel(networkModel) {
  const fileInfo = Object.fromEntries(networkModel["files"].map((file) => {
    return [file.id, file.title];
  }));
  const trackFileStatistics = networkModel["track_file_statistics"].map((trackFileStatistic) => {
    return {
      title: fileInfo[trackFileStatistic["file_id"]],
      count: trackFileStatistic["count"],
      date: new Date(trackFileStatistic["updated_at"]),
    };
  });
  return {
    id: networkModel["id"],
    clientCode: networkModel["client_code"],
    productCode: networkModel["product_code"],
    title: networkModel["name"],
    date: new Date(networkModel["updated_at"]),
    trackFileStatistics: trackFileStatistics,
  };
}

function createPaginationItems(response) {
  const totalCount = response.data["response"]["count"];
  const pageSize = response.data["response"]["limit"];
  const offset = response.data["response"]["offset"];
  const maxVisiblePageButtons = 3;

  const totalPages = Math.ceil(totalCount / pageSize);
  const currentPage = Math.floor(offset / pageSize) + 1;

  const halfRange = Math.floor(maxVisiblePageButtons / 2);

  let startPage = currentPage - halfRange;
  let endPage = currentPage + halfRange;

  if (maxVisiblePageButtons >= totalPages) {
    startPage = 1;
    endPage = totalPages;
  } else if (startPage < 1) {
    startPage = 1;
    endPage = Math.min(totalPages, maxVisiblePageButtons);
  } else if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, totalPages - maxVisiblePageButtons);
  }

  return range(startPage, endPage)
    .map((pageNumber => {
      return createPaginationItem(pageNumber)
    }));
}